<style lang="scss" scoped>
/deep/ .comp-employee-policy-dialog {
    max-width: 1200px;
    margin-top: 4vh !important;

    .el-dialog__body {
        padding: 12px 18px 18px;
    }
}

.comp-employee-policy-import-result {
    p {
        margin: 0 0 10px;
        line-height: 1.7;
    }
}
</style>

<template>
    <el-dialog title="保单数据" custom-class="c-el-dialog comp-employee-policy-dialog" :visible.sync="showDialog"
        :before-close="_close">
        <div class="toolbars mrgb5">
            <div class="buttons mrgb5">
                <div class="fl">
                    <!-- 新增保单 -->
                    <el-button class="mrgr5 mrgb5" type="primary" size="medium" @click="edit()">
                        <i class="fa fa-plus"></i> 新增保单
                    </el-button>
                    <!-- JSON 导入 -->
                    <el-upload class="dib mrgr5 mrgb5" action="#" accept=".json,application/json"
                        :http-request="uploadImport" :show-file-list="false" :disabled="importing">
                        <el-button type="warning" size="medium" :loading="importing">
                            <i class="fa fa-sign-in"></i> 导入保单
                        </el-button>
                    </el-upload>
                    <!-- JSON 导出（可直接回导） -->
                    <el-button class="mrgr5 mrgb5" type="danger" size="medium" @click="exportData()">
                        <i class="fa fa-sign-out"></i> 导出保单
                    </el-button>
                    <!-- 存量人员保险一次性迁移（幂等） -->
                    <el-button class="mrgr5 mrgb5" type="success" size="medium" @click="migrateLegacy()">
                        <i class="fa fa-exchange"></i> 迁移旧保险数据
                    </el-button>
                </div>
                <div class="fr">
                    <el-input class="c-el-input mrgr5 mrgb5" placeholder="保单号/险种/保险公司/被保人" clearable
                        v-model="listQuery.keywords" size="medium" @keyup.enter.native="_search()"></el-input>
                    <el-button class="mrgb5" type="primary" size="medium" @click="_search()">
                        <i class="fa fa-search"></i> 查询
                    </el-button>
                </div>
                <div class="clearb"></div>
            </div>
        </div>
        <div>
            <el-table :data="tableData" style="width: 100%" border size="small">
                <el-table-column label="保单号" prop="policyNumber" min-width="160" show-overflow-tooltip></el-table-column>
                <el-table-column label="险种" prop="policyType" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column label="保险公司" prop="company" min-width="130" show-overflow-tooltip></el-table-column>
                <el-table-column label="承保分公司" prop="underwritingBranch" min-width="150" show-overflow-tooltip></el-table-column>
                <el-table-column label="被保人" prop="insuredName" min-width="110" show-overflow-tooltip></el-table-column>
                <el-table-column label="保单开始日期" prop="startDate" :formatter="formatDate" width="110"></el-table-column>
                <el-table-column label="保单结束日期" prop="endDate" :formatter="formatDate" width="110"></el-table-column>
                <el-table-column label="绑定数" prop="bindingCount" width="80" align="center"></el-table-column>
                <el-table-column label="备注" prop="remark" min-width="120" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" align="center" width="140" fixed="right">
                    <template slot-scope="scope">
                        <el-button class="op-btn" type="primary" plain size="mini" @click="edit(scope.row)">编辑</el-button>
                        <el-button class="op-btn" type="info" plain size="mini" @click="remove(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination-container" v-if="isPagination">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="listQuery.page" :page-sizes="appPageSizes" :page-size="listQuery.size"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>
        <!-- 新增/编辑保单 -->
        <el-dialog :title="(form.id ? '编辑保单' : '新增保单')" :visible.sync="editing" append-to-body
            custom-class="c-el-dialog comp-employee-policy-form-dialog" :close-on-click-modal="false">
            <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
                <el-form-item label="保单号" prop="policyNumber">
                    <el-input v-model.trim="form.policyNumber" :disabled="!!form.id" maxlength="100"
                        placeholder="保单号唯一，创建后不可修改"></el-input>
                </el-form-item>
                <el-form-item label="险种" prop="policyType">
                    <el-input v-model.trim="form.policyType" maxlength="100"></el-input>
                </el-form-item>
                <el-form-item label="保险公司" prop="company">
                    <el-input v-model.trim="form.company" maxlength="100"></el-input>
                </el-form-item>
                <el-form-item label="承保分公司" prop="underwritingBranch">
                    <el-input v-model.trim="form.underwritingBranch" maxlength="100"></el-input>
                </el-form-item>
                <el-form-item label="被保人" prop="insuredName">
                    <el-input v-model.trim="form.insuredName" maxlength="100"></el-input>
                </el-form-item>
                <el-form-item label="开始日期" prop="startDate">
                    <el-date-picker v-model="form.startDate" type="date" value-format="yyyy-MM-dd" clearable
                        style="width: 100%"></el-date-picker>
                </el-form-item>
                <el-form-item label="结束日期" prop="endDate">
                    <el-date-picker v-model="form.endDate" type="date" value-format="yyyy-MM-dd" clearable
                        style="width: 100%"></el-date-picker>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input v-model.trim="form.remark" type="textarea" :rows="2" maxlength="500" show-word-limit></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button :disabled="saving" @click="editing = false">取消</el-button>
                <el-button type="primary" :loading="saving" @click="save">保存</el-button>
            </span>
        </el-dialog>
        <!-- 导入结果 -->
        <el-dialog title="保单导入结果" :visible.sync="importResultVisible" append-to-body
            custom-class="c-el-dialog comp-employee-policy-result-dialog">
            <div class="comp-employee-policy-import-result" v-if="importResult">
                <p>总数 {{ importResult.totalCount }} · 新增 {{ importResult.addedCount }} · 更新
                    {{ importResult.updatedCount }} · 跳过 {{ importResult.skippedCount }}</p>
                <el-table :data="importResult.errors || []" style="width: 100%" max-height="320" border size="small"
                    empty-text="无跳过明细">
                    <el-table-column prop="row" label="行号" width="80"></el-table-column>
                    <el-table-column prop="message" label="跳过原因" min-width="300"></el-table-column>
                </el-table>
            </div>
            <span slot="footer">
                <el-button type="primary" @click="importResultVisible = false">知道了</el-button>
            </span>
        </el-dialog>
    </el-dialog>
</template>

<script>
import saveAs from "file-saver"
import * as funEmployee from "@/api/employees"
import moment from "moment"

export default {
    name: "compEmployeePolicyDialog",
    data() {
        return {
            showDialog: false,
            tableData: [],
            total: null,
            isPagination: false,
            listQuery: {
                keywords: "",
                page: 1,
                size: 10
            },
            editing: false,
            saving: false,
            importing: false,
            importResultVisible: false,
            importResult: null,
            form: {},
            rules: {
                policyNumber: [{ required: true, message: "请输入保单号", trigger: "blur" }]
            }
        }
    },
    methods: {
        open() {
            this.showDialog = true
            this._search()
        },
        _close() {
            this.showDialog = false
            // 保单数据可能影响主列表（保险公司等），关闭时让父页面刷新
            this.$emit("changed")
        },
        handleSizeChange(val) {
            this.listQuery.size = val
            this.getDataList()
        },
        handleCurrentChange(val) {
            this.listQuery.page = val
            this.getDataList()
        },
        _search() {
            this.listQuery.page = 1
            this.getDataList()
        },
        getDataList() {
            const params = JSON.parse(JSON.stringify(this.listQuery))
            funEmployee.GetEmployeePolicies(params).then(response => {
                this.total = response.totalCount
                this.isPagination = response.totalCount > 0 || false
                this.tableData = (response && response.items) || []
            })
        },
        formatDate(row, column, cellValue) {
            return cellValue ? moment(cellValue).format("YYYY-MM-DD") : ""
        },
        // 新增/编辑保单
        edit(row) {
            this.form = row ? {
                id: row.id,
                policyNumber: row.policyNumber,
                policyType: row.policyType || "",
                company: row.company || "",
                underwritingBranch: row.underwritingBranch || "",
                insuredName: row.insuredName || "",
                startDate: row.startDate ? moment(row.startDate).format("YYYY-MM-DD") : null,
                endDate: row.endDate ? moment(row.endDate).format("YYYY-MM-DD") : null,
                remark: row.remark || ""
            } : {
                id: null,
                policyNumber: "",
                policyType: "",
                company: "",
                underwritingBranch: "",
                insuredName: "",
                startDate: null,
                endDate: null,
                remark: ""
            }
            this.editing = true
            this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
        },
        save() {
            this.$refs.form.validate(valid => {
                if (!valid) return
                if (this.form.startDate && this.form.endDate && this.form.endDate < this.form.startDate) {
                    this.alert("保单结束日期不能早于开始日期！")
                    return
                }
                this.saving = true
                const data = {
                    policyNumber: this.form.policyNumber,
                    policyType: this.form.policyType,
                    company: this.form.company,
                    underwritingBranch: this.form.underwritingBranch,
                    insuredName: this.form.insuredName,
                    startDate: this.form.startDate,
                    endDate: this.form.endDate,
                    remark: this.form.remark
                }
                const request = this.form.id
                    ? funEmployee.UpdateEmployeePolicy(this.form.id, data)
                    : funEmployee.CreateEmployeePolicy(data)
                request.then(() => {
                    this.editing = false
                    this.$message.success("保存成功")
                    this.getDataList()
                }).finally(() => {
                    this.saving = false
                })
            })
        },
        remove(row) {
            this.$confirm(`确认删除保单 ${row.policyNumber}？有员工绑定的保单不能删除。`, "删除保单", { type: "warning" })
                .then(() => funEmployee.DeleteEmployeePolicy(row.id))
                .then(() => {
                    this.$message.success("删除成功")
                    this.getDataList()
                }).catch(() => { })
        },
        // JSON 导入（按保单号新增/更新）
        uploadImport(option) {
            const file = option.file
            if (!/\.json$/i.test(file.name)) {
                this.alert("请选择 JSON 文件！")
                return
            }
            this.importing = true
            window.$common.fullLoading()
            funEmployee.ImportEmployeePolicy(file).then(response => {
                window.$common.closeFullLoading()
                this.importResult = response
                this.importResultVisible = true
                this._search()
            }).catch(() => {
                window.$common.closeFullLoading()
            }).finally(() => {
                this.importing = false
            })
        },
        // JSON 导出（可直接回导）
        exportData() {
            window.$common.fullLoading()
            const params = JSON.parse(JSON.stringify(this.listQuery))
            delete params.page
            delete params.size
            funEmployee.ExportEmployeePolicy(params).then(response => {
                window.$common.closeFullLoading()
                saveAs(response, `员工保单_${moment().format("YYYYMMDDHHmmss")}.json`)
            }).catch(() => {
                window.$common.closeFullLoading()
            })
        },
        // 存量人员保险一次性迁移（幂等可重复执行）
        migrateLegacy() {
            this.$confirm("把旧「人员保险」数据一次性迁移为「保单主档 + 员工绑定」，迁移幂等可重复执行，确认执行？",
                "迁移旧保险数据", { type: "warning" })
                .then(() => {
                    window.$common.fullLoading()
                    return funEmployee.MigrateLegacyEmployeeInsurance()
                })
                .then(response => {
                    window.$common.closeFullLoading()
                    const errors = (response && response.errors) || []
                    const errorText = errors.length > 0
                        ? `，其中 ${errors.length} 条明细跳过（前 3 条：${errors.slice(0, 3).map(t => t.message).join("；")}）`
                        : ""
                    this.alert(`迁移完成：存量 ${response.legacyTotalCount} 条，新建保单 ${response.policyCreatedCount} 个，` +
                        `新建绑定 ${response.bindingCreatedCount} 条，跳过 ${response.skippedCount} 条${errorText}。`)
                    this._search()
                })
                .catch(() => {
                    window.$common.closeFullLoading()
                })
        }
    }
}
</script>
